import {FC, useEffect, useState} from 'react';
import styles from './Deposit.module.scss';
import {calculateDaysPassedAndTotal, formatDateFromNumber, getDeltaOfDate} from '../../lib';
import {mellIcon, portfel} from '../../../../assets';
import {ContractAddress, TDeposit} from '../../../../shared/api/contract';
import Earn from '../../../../shared/ui/Eearn/Earn';
import ProgressBar from '../../../../shared/ui/ProgressBar/ProgressBar';
import Button from '../../../../shared/ui/Button/Button';
import {WithdrawDepositService} from '../../api/withdraw-deposit-service';
import {contractABI} from '../../../../shared/api/contract/config';
import {ConnectorType, useAppKitProvider} from '@reown/appkit/react';
import {useAccount} from 'wagmi';
import Loader from '../../../../shared/ui/Loader/Loader';
import {MoonStaking} from '../../../../shared/api/contract/ethers/moon-staking';
import {useNavigate} from 'react-router';
import {useTranslation} from 'react-i18next';
import {GetMainRewardService} from "../../api/get-mainreward-service.ts";

const Deposit: FC<TDeposit & { reload: () => void }> = (props) => {
    const [dates, setDates] = useState<{ passed: number; total: number }>();
    const [mainReard, setMainReward] = useState()
    const [pending, setPending] = useState(false);
    const [msg, setMsg] = useState('');

    const {walletProvider} = useAppKitProvider<ConnectorType>('eip155');
    const {address} = useAccount();

    const navigate = useNavigate();
    const {t} = useTranslation();

    const withdrawDepositService = address // withdraw service
        ? new WithdrawDepositService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address)
        : undefined;
    const moonStackingService = address ? new MoonStaking(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined; // moon stacking service

    useEffect(() => {
        if (!address) return;
        const [passed, total] = calculateDaysPassedAndTotal(props.lockEnds, Number(props.weight), Number(props.depositedAmount));

        setDates({passed, total});
    }, []);


    async function withdraw(address: ContractAddress, index: bigint) {
        if (!address || !withdrawDepositService || !moonStackingService) return;
        setPending(true);

        const genneralSettings = await moonStackingService.getGeneralSettings();

        if (!genneralSettings) return setPending(false);

        const withdrawStatus = await withdrawDepositService.withdraw(
            index,
            props.rewards.length,
            Number(genneralSettings.maxIterationsPerIndex),
            (msg) => setMsg(msg)
        );

        if (withdrawStatus === 'error') {
            setPending(false);
            setMsg('');
            return;
        }

        if (withdrawStatus === 'claim') return navigate('/contract/bonuses', {state: {claim: true}});

        await withdrawDepositService.saveDeposit([
            {
                accumulator: String(props.accumulator),
                depositedAmount: String(props.depositedAmount),
                lastRewardDeposit: String(props.lastRewardDeposit),
                lockEnds: String(props.lockEnds),
                weight: String(props.weight),
                reward: String(props.reward),
                rewards: withdrawDepositService.formatIntToString(props.rewards),
                status: 'done',
                index: String(props.index),
                wallet: address,
            },
        ]);

        console.log(`deposit ${props.index} saved on server`);

        props.reload();
    }

    return (
        <>
            {dates && (
                <>
                    <div
                        className={styles.Deposit + ' start-animation'}
                        style={{opacity: pending ? 0.5 : 1}}>
                        <div className={styles.header}>
                            <div className={styles.title}>
                                <img
                                    src={mellIcon}
                                    alt=""
                                />
                                <p>
                                    {Number(Number(props.depositedAmount).toFixed(0)).toLocaleString()}

                                    <span>MOON</span>
                                </p>
                            </div>

                            {new Date().getTime() >= new Date(props.lockEnds * 1000).getTime() && !props.status && (
                                <Button
                                    title={t('wallet.btns.withdraw')}
                                    width="76px"
                                    height="26px"
                                    fontSize="12px"
                                    // pending={pending}
                                    onClick={async () => address && (await withdraw(address, props.index))}
                                />
                            )}

                            {props.status && <div className={styles.done}>{t('lock_done')}</div>}
                        </div>

                        <div className={styles.info}>
                            {new Date().getTime() >= new Date(props.lockEnds * 1000).getTime() ? (
                                <>
                                    <div className={styles.inner}>
                                        <div className={styles.item}>
                                            <h3>{t('lock_period')}</h3>
                                        </div>
                                        <div className={styles.item}>
                                            <h3>{getDeltaOfDate(props.lockEnds, Number(props.weight), Number(props.depositedAmount))}</h3>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.inner}>
                                        <div className={styles.item}>
                                            <img
                                                src={portfel}
                                                alt=""
                                            />
                                            <h2>{t('days_off')}</h2>
                                        </div>
                                        <div className={styles.item}>
                                            <h1>
                                                {dates.total - dates.passed} <h2>из</h2> {dates.total}
                                            </h1>
                                        </div>
                                    </div>

                                    <ProgressBar percent={(dates.passed * 100) / dates.total}/>

                                    <div className={styles.inner}>
                                        <div className={styles.item}>
                                            <h3>{t('lock_date')}</h3>
                                        </div>
                                        <div className={styles.item}>
                                            <h3>{formatDateFromNumber(props.lockEnds)}</h3>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {
                            address && <Earn
                                address={address}
                                index={props.status ? null : props.index}
                                reward={props.reward}
                                additionalsReawds={props.rewards}
                            />
                        }
                    </div>

                    {pending && (
                        <div className="shadow">
                            <Loader/>
                            <h1 dangerouslySetInnerHTML={{__html: msg}}></h1>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default Deposit;
